import { render } from "./FamilyFilter.vue?vue&type=template&id=4d5148b5"
import script from "./FamilyFilter.vue?vue&type=script&lang=js"
export * from "./FamilyFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__